import styled from "@emotion/styled";
import { AnimatePresence, motion } from "motion/react";
import { type ComponentProps } from "react";

import { zIndexes } from "../utilities/zIndexes";
import type { Control } from "./AppContext";

const toolBarIconSize = 36;

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;

  display: flex;
  align-items: center;

  width: ${toolBarIconSize}px;

  background-color: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.generalTextIcon};

  overflow: hidden;

  transition:
    left 300ms ease-in-out,
    top 300ms ease-in-out;

  z-index: ${zIndexes.applicationToolbar};
`;

const Anchor = styled.div`
  position: fixed;
`;

const ControlsContainer = styled.div`
  position: relative;
  top: 0;
  left: 0;

  display: flex;
  flex-direction: column;

  width: ${toolBarIconSize}px;
  height: fit-content;

  background-color: ${({ theme }) => theme.surface};
  border-radius: 4px;

  box-shadow: ${({ theme }) => theme.boxShadow.normal};

  overflow: hidden;

  transition: all 300ms ease-in-out;
`;

type Props = ComponentProps<"div"> & {
  control: Control | null;
};

export const ApplicationToolbar = ({ control, ...props }: Props) => {
  return (
    <Container
      {...props}
      style={{
        ...props.style,
        left: `calc(${props?.style?.left ?? 0} + ${control?.anchorOffset?.left ?? 0}px)`,
        top: `calc(${props?.style?.top ?? 0} + ${control?.anchorOffset?.top ?? 0}px)`,
      }}
    >
      <AnimatePresence>
        {control && (
          <motion.div
            key="control"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <Anchor>
              <ControlsContainer>{control.component}</ControlsContainer>
            </Anchor>
          </motion.div>
        )}
      </AnimatePresence>
    </Container>
  );
};
